import React from 'react';
import { Box, Stack } from '@mui/material';
import { BasePrice } from 'modules/equipment/types';
import { CurrencyInputField } from 'components/form';
import { ListingForm } from 'components/shared/TableListing/types';
import { FieldPath, useFormContext, useWatch } from 'react-hook-form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { AttachmentChargeValue } from './AttachmentChargeValue';
import { QuoteChargeListingEntity, QuoteLineItemType } from '../../../../../types';
import { CHARGE_ROW_HEIGHT } from '../../../../../constants/form';

interface Props {
  rowIndex: number;
  type: keyof BasePrice;
}

export const ChargeValueCell = ({ type, rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const fields: Record<QuoteLineItemType, Record<'valuePath', FieldPath<ListingForm<QuoteChargeListingEntity>>>> = {
    [QuoteLineItemType.Equipment]: {
      valuePath: `bodyFields.${rowIndex}.equipment.price.${type}`,
    },
    [QuoteLineItemType.Invoice]: {
      valuePath: `bodyFields.${rowIndex}.charge.price.${type}`,
    },
  };

  const { type: cellType, equipment } = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const renderWithAttachments = cellType === QuoteLineItemType.Equipment && !!equipment?.attachments?.length;

  return (
    <Stack width="100%" height="100%" gap="0.5rem" justifyContent="flex-end">
      <Box height="100%">
        <CurrencyInputField
          allowNegative
          control={control}
          name={fields[cellType].valuePath}
          textFieldProps={{
            variant: 'outlined',
          }}
        />
      </Box>

      <RenderWithCondition condition={!!equipment?.attachments}>
        {equipment?.attachments?.map((_, index) => (
          <Box height={CHARGE_ROW_HEIGHT} sx={{ mb: renderWithAttachments ? '2.6rem' : 0 }}>
            <AttachmentChargeValue key={index} type={type} rowIndex={rowIndex} attachmentIndex={index} />
          </Box>
        ))}
      </RenderWithCondition>
    </Stack>
  );
};
